import { useLang } from "../../lib/LanguageContext";
import { BRAND } from "../../lib/brand";
import { Instagram, Facebook, Youtube, Mail } from "lucide-react";

export default function Footer() {
  const { t } = useLang();

  const cols = [
    { title: t.footer.product, items: [t.nav.features, t.nav.howItWorks, t.nav.ecosystem] },
    { title: t.footer.company, items: [t.footer.about, t.footer.careers, t.footer.contact] },
    { title: t.footer.resources, items: [t.footer.blog, t.footer.help, t.nav.faq] },
    { title: t.footer.legal, items: [t.footer.terms, t.footer.privacy] },
  ];

  return (
    <footer className="bg-white border-t border-soft pt-16 pb-8" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-6">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5 mb-4">
              <img src={BRAND.logoIcon} alt="AsiaCommerce" className="w-10 h-10 object-contain" />
              <span className="font-display font-extrabold text-xl text-ink">
                Asia<span className="text-brand-red">Commerce</span>
                <span className="ml-1 text-xs align-top bg-brand-orange text-white px-1.5 py-0.5 rounded font-bold">HUB</span>
              </span>
            </div>
            <p className="text-ink-muted text-sm leading-relaxed max-w-sm">
              {t.footer.tagline}. The B2B wholesale ecosystem for smart resellers sourcing unique products from local & global suppliers.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[Instagram, Facebook, Youtube, Mail].map((Icon, i) => (
                <a key={i} href="#" className="w-10 h-10 rounded-full bg-cream border border-soft flex items-center justify-center text-ink-muted hover:text-brand-red hover:border-brand-red transition-colors" data-testid={`footer-social-${i}`}>
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-2 sm:grid-cols-4 gap-6">
            {cols.map((col) => (
              <div key={col.title}>
                <h4 className="font-display font-bold text-ink text-sm uppercase tracking-wider mb-4">{col.title}</h4>
                <ul className="space-y-2.5">
                  {col.items.map((it) => (
                    <li key={it}>
                      <a href="#" className="text-sm text-ink-muted hover:text-brand-red transition-colors">{it}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-soft flex flex-col sm:flex-row justify-between items-center gap-3">
          <p className="text-xs text-ink-muted">{t.footer.copy}</p>
          <div className="flex items-center gap-4 text-xs text-ink-muted">
            <span>🇮🇩 Made in Indonesia</span>
            <span>·</span>
            <span>🌏 Powered by global suppliers</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
